var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popup-table",
      class: _vm.is_full_height ? "full-height" : "",
      attrs: { id: "alert_table" }
    },
    [
      _c(
        "div",
        {
          staticClass: "popup-table__wrapper",
          class: _vm.is_minimize ? "h-45px" : "h-100vh",
          staticStyle: { "min-height": "0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "popup-table__container-title",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.alerts.title))]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.is_full_height
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "maximize-btn",
                          staticStyle: { display: "inline-block" },
                          attrs: { color: "white", icon: "" },
                          on: {
                            click: function($event) {
                              _vm.is_minimize = !_vm.is_minimize
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.is_minimize
                                    ? "mdi-window-maximize"
                                    : "mdi-window-minimize"
                                ) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "close-btn",
                      attrs: { color: "black", icon: "" },
                      on: { click: _vm.close_dialog }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v(
                          "\n                        mdi-close\n                    "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "popup-table__container",
              class: _vm.is_minimize ? "h-0vh" : "h-100vh"
            },
            [
              _c(
                "div",
                { staticClass: "popup-table__content-wrapper" },
                [
                  [
                    _c(
                      "div",
                      { staticClass: "popup-table__content one-column" },
                      _vm._l(_vm.alerts.data, function(datum, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "popup-table__content-item"
                          },
                          _vm._l(Object.entries(datum), function(ref, index) {
                            var sub_header = ref[0]
                            var content = ref[1]
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "alert-table__content-wrapper"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "alert-table__sub-header" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(sub_header) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "alert-table__content" },
                                  [
                                    _c("p", {
                                      domProps: { innerHTML: _vm._s(content) }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      }),
                      0
                    )
                  ]
                ],
                2
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }